U.googleTranslateSyncHiddenControls = function() {
	let hidden_voting_pane = document.getElementById('goog-gt-votingHiddenPane')
	if (hidden_voting_pane) {
		// Google injects this voting form for internal feedback flows. It is not part of
		// our UI, starts hidden, and should not appear in tab order or the accessibility tree.
		hidden_voting_pane.setAttribute('hidden', 'hidden')
		hidden_voting_pane.setAttribute('aria-hidden', 'true')
		hidden_voting_pane.setAttribute('inert', '')

		hidden_voting_pane.querySelectorAll('input, button, select, textarea, a').forEach(el => {
			el.setAttribute('tabindex', '-1')
			el.setAttribute('aria-hidden', 'true')
		})

		let hidden_control_labels = {
			'goog-gt-votingInputSrcLang': 'Hidden Google Translate source language input',
			'goog-gt-votingInputTrgLang': 'Hidden Google Translate target language input',
			'goog-gt-votingInputSrcText': 'Hidden Google Translate source text input',
			'goog-gt-votingInputTrgText': 'Hidden Google Translate translated text input',
			'goog-gt-votingInputVote': 'Hidden Google Translate vote input',
		}
		Object.entries(hidden_control_labels).forEach(([id, label]) => {
			let input = document.getElementById(id)
			if (!input) return
			input.setAttribute('aria-label', label)
			input.setAttribute('title', label)
		})
	}

	let voting_frame = document.querySelector('iframe[name="votingFrame"]')
	if (voting_frame) {
		voting_frame.setAttribute('hidden', 'hidden')
		voting_frame.setAttribute('aria-hidden', 'true')
		voting_frame.setAttribute('tabindex', '-1')
	}
}

U.googleTranslateElementInit = function() {
	// uncomment the below to cancel google translate functionality
	// $('#google_translate_element_wrapper').hide()
	// return

	// the google_translate_element appears to need to be both in the DOM and visible for the GT initialization to work properly
	if ($('#google_translate_element').length > 0 && $('#google_translate_element').is(':visible')) {
		// console.log('INITIALIZING GOOGLE TRANSLATE ELEMENT')
		window.google_translate_element = new google.translate.TranslateElement({
			pageLanguage: window.__gt_page_language || 'en',
			// https://clearwordstranslations.com/language/en/most-popular-languages/#:~:text=Besides%20English%2C%20the%20next%20most,%2C%20Russian%2C%20French%20and%20German.
			// Besides English, the next most used languages online are Chinese, Spanish, Arabic, Portuguese, Indonesian, Japanese, Russian, French and German
			// if pageLanguage is specified, we don't see that language in the list to translate to
			// pageLanguage: 'en', 
			includedLanguages: 
					'en'	// English
					+',es'	// Spanish
					+',vi'	// Vietnamese
					+',fr'	// French
					+',zh-CN' // Chinese Simplified
					+',zh-TW' // Chinese Traditional
					+',hi'	// Hindi
					+',ar'	// Arabic
					+',id'	// Indonesian
					+',ja'	// Japanese
					+',no'	// Norwegian
					+',de'	// German
					+',it'	// Italian
					+',ko'	// Korean
					+',sv'	// Swedish
					+',th'	// Thai
					+',tr'	// Turkish
					+',uk'	// Ukranian
					+',sw'	// Swahili
					+',da'  // Danish
					+',nl'	// Dutch
					+',fil'	// Filipino
					+',ru'	// Russian
					+',mi'	// Maori
					+',pt'	// Portuguese
					+',fi'	// Finnish
					+',iw'	// Hebrew
					+',ur'	// Urdu
					+',ms'	// Malay	
					+',cy' //Welsh
					// +',pt-PT'	// Portuguese (Portugal) -- this and the brazil variant don't seem to work
					// +',pt-BR'	// Portuguese (Brazil)
			,
			layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
			autoDisplay: false,
		}, 'google_translate_element'
		)
		U.googleTranslateSyncHiddenControls()
	} else {
		// console.log('GOOGLE TRANSLATE ELEMENT NOT READY; TRY AGAIN...')
		setTimeout(U.googleTranslateElementInit, 50)
	}
}

U.googleTranslateRestoreOriginal = function() {
	// try to find the "restore" btn in the google translate toolbar (which may be hidden); if we find it, click it
	let iframe = $('.skiptranslate iframe.skiptranslate')[0]

	if (!iframe) {
		console.log('googleTranslateRestoreOriginal: couldn’t get iframe')
		return false
	}

	// NOTE: this may not work forever; google could change this "magic identifier" at any time
	let btn = iframe.contentDocument.getElementById(':2.restore')
	if (!btn) {
		console.log('googleTranslateRestoreOriginal: couldn’t get button')
		return false
	}

	if (btn) btn.click()
}

U.googleTranslateGetCurrentLanguage = function() {
	const s = U.cookie_get('googtrans', '', false)
	const m = s.match(/^\/[^/]+\/([A-Za-z-]+)$/)
	return m ? m[1] : ''
}
